var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 11.009C5 9.899 5.897 9 7.006 9H16.994C17.5262 9.00106 18.0363 9.21316 18.4123 9.58977C18.7884 9.96639 18.9997 10.4768 19 11.009V18.991C19 20.101 18.103 21 16.994 21H7.006C6.4737 20.9992 5.96347 20.7872 5.58736 20.4105C5.21125 20.0338 5 19.5233 5 18.991V11.009ZM12 17C12.5304 17 13.0391 16.7893 13.4142 16.4142C13.7893 16.0391 14 15.5304 14 15C14 14.4696 13.7893 13.9609 13.4142 13.5858C13.0391 13.2107 12.5304 13 12 13C11.4696 13 10.9609 13.2107 10.5858 13.5858C10.2107 13.9609 10 14.4696 10 15C10 15.5304 10.2107 16.0391 10.5858 16.4142C10.9609 16.7893 11.4696 17 12 17Z",
    fill: "#252728"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.002C8.00053 4.94111 8.42206 3.9238 9.17204 3.17345C9.92201 2.4231 10.9391 2.00106 12 2C12.5255 2 13.0458 2.10353 13.5312 2.30467C14.0166 2.50582 14.4577 2.80063 14.8291 3.17228C15.2006 3.54393 15.4952 3.98512 15.6961 4.47065C15.897 4.95619 16.0003 5.47654 16 6.002V6.5H14V6.002C14.0001 5.73922 13.9485 5.479 13.8481 5.23617C13.7476 4.99335 13.6003 4.77269 13.4146 4.58679C13.2289 4.40088 13.0084 4.25338 12.7657 4.1527C12.523 4.05202 12.2628 4.00013 12 4C10.898 4 10 4.898 10 6.002V11H8V6.002ZM14 6.5H16C16 6.76522 15.8946 7.01957 15.7071 7.20711C15.5196 7.39464 15.2652 7.5 15 7.5C14.7348 7.5 14.4804 7.39464 14.2929 7.20711C14.1054 7.01957 14 6.76522 14 6.5Z",
    fill: "#252728"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.962a978874279cdd52fbc8a9b97ec0c9.svg";
export { ForwardRef as ReactComponent };